import shiftRequestDetailsStore from "../../store/store";
import { mutatorAction } from "satcheljs";

export default mutatorAction('SET_OTHER_SHIFT_NOT_FOUND', function setOtherShiftNotFoundInStore(otherShiftNotFound: boolean) {
    if (shiftRequestDetailsStore) {
        shiftRequestDetailsStore.otherShiftNotFound = otherShiftNotFound;
    }
});
